import { CssBaseline, ThemeProvider } from "@mui/material";
import { useRoutes } from "react-router-dom";
import Router from "./routes/Router";

import React from "react";
import { UserProvider } from "./context";
import { baselightTheme } from "./theme/DefaultColors";

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Chunk Load Error:", error);
    console.error("Additional Info:", errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <h1></h1>;
    }
    return this.props.children;
  }
}

function App() {
  const routing = useRoutes(Router);
  const theme = baselightTheme;

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [location]);

  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <UserProvider>
          <CssBaseline />
          {routing}
        </UserProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
